var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChange = function SvgChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "change_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".change_svg__st1{fill:#d90b17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 802.2c-28.8 26-56.5 50.9-86.9 78.4V579h327.6c-49.6 46.3-95.5 89.2-144.4 134.9 69 111 172.3 168.5 297.9 170.1 207.5 2.6 331.4-112.1 387-307.2h115.1c8.6 133.4-124.1 320.6-278.9 385.1-211.5 88-422.5 64.9-617.4-159.7M136.5 445.8H21.6c-4.4-141.9 128.1-318.2 286-390.1C476.2-20.9 751.3-5.6 922 229.3c26.3-29.2 52.3-58 81.9-90.7v306.3H702c44.6-41.7 86-80.4 126.8-118.6-49-109.9-195.1-197-328.1-189.3-196.9 11.3-312.9 123-364.2 308.8",
    className: "change_svg__st1"
  })));
};
export default SvgChange;